let activeRow = null;

function openDetails(row) {
  const panel = row.closest("[data-report-fullscreen-panel]");
  const dialog = panel?.querySelector("[data-billing-preview-dialog]");
  const template = row.querySelector("[data-billing-preview-detail-template]");
  if (!dialog || !template || dialog.open) return;
  dialog.querySelector("[data-billing-preview-detail-content]").replaceChildren(template.content.cloneNode(true));
  activeRow = row;
  dialog.addEventListener("close", () => {
    if (activeRow?.isConnected) activeRow.focus();
    activeRow = null;
  }, { once: true });
  dialog.showModal();
}

document.addEventListener("click", (event) => {
  if (!(event.target instanceof Element)) return;
  const closeButton = event.target.closest("[data-billing-preview-close]");
  if (closeButton) {
    closeButton.closest("dialog").close();
    return;
  }
  if (event.target.matches("[data-billing-preview-dialog]")) {
    event.target.close();
    return;
  }
  const row = event.target.closest("[data-billing-preview-row]");
  if (row && !event.target.closest("a, input, select, textarea")) openDetails(row);
});

document.addEventListener("keydown", (event) => {
  if (!(event.target instanceof Element) || !event.target.matches("[data-billing-preview-row]")) return;
  if (event.key === "Enter" || event.key === " ") {
    event.preventDefault();
    openDetails(event.target);
  }
});

document.addEventListener("turbo:before-cache", () => {
  activeRow = null;
  document.querySelectorAll("[data-billing-preview-dialog][open]").forEach((dialog) => dialog.close());
});
